import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes,ExtraOptions  } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeGridComponent } from './home/home-grid/home-grid.component';
import { NewVulnerabilityComponent } from './new-vulnerability/new-vulnerability.component';
import { ErrorComponent } from './error/error.component';
import { CellDataRenderComp } from './home/home-grid/CellDataRenderComp';
import { NewAssessmentComponent } from './assessment/new-assessment.component';
import { DataResolverService } from './Data Service/data-resolver.service';
import { UserViewVulnerabilityComponent } from './user-view-vulnerability/user-view-vulnerability.component';
import { MsalGuard } from '@azure/msal-angular';
import { RolegaurdService } from './Data Service/rolegaurd.service';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import{CellDataRenderComp_Assess}from 'src/app/assessment/assessment-home/CellDataRenderComp_Assess'
import{AssessmentHomeComponent} from 'src/app/assessment/assessment-home/assessment-home.component'
import { UserViewAssessmentComponent } from './assessment/user-view-assessment/user-view-assessment.component';
import{LoginErrorComponent} from './login-error/login-error.component';
import { AdminViewComponent } from './Admin/admin-view/admin-view.component';

const routes: Routes = [

  // {path:'home',component:HomeGridComponent , resolve:{data : DataResolverService}},
  {
    path: 'home', component: HomeGridComponent
  },
  {
    path: 'assessment-home', component: AssessmentHomeComponent
  },
  {path:'userview-assessment/:id', component: UserViewAssessmentComponent},
  {
    path: 'newvulnerability/:id', component: NewVulnerabilityComponent
    // , canActivate: [
      
    //   RolegaurdService
    // ],
    // data: {
    //   expectedRole: "Users",
    //   requiredRole: "Admin"
    // }
  },
  {
    path: 'LoginError', component: LoginErrorComponent
  },
  // {path:'login'}
  
  {
    path: 'newassessment/:id', component: NewAssessmentComponent
    // , canActivate: [
    //   //MsalGuard,
    //   RolegaurdService
    // ],
    // data: {
    //   expectedRole: "Admin"
    // }
  },
  {
    path: 'maintenance/:id', component: MaintenanceComponent
    // , canActivate: [
      
    //   RolegaurdService
    // ],
    // data: {
    //   expectedRole: "Users",
    //   requiredRole: "Admin"
    // }
  },
  // {
  //   path: '', redirectTo: '/home', pathMatch: 'full'
  // },
  { path: 'error', component: ErrorComponent },
  { path: 'CellDataRenderComp', component: CellDataRenderComp },
  { path: 'CellDataRenderComp_Assess', component: CellDataRenderComp_Assess },
  {
    path: 'UserView', component: UserViewVulnerabilityComponent,
    //  canActivate: [
    //   //MsalGuard,
    //   RolegaurdService
    // ],
    // data: {
    //   expectedRole: "Users",
    //   requiredRole : "Admin"
    // }
  },
  {
    path: 'Admin', component: AdminViewComponent,
    //  canActivate: [
    //   //MsalGuard,
    //   RolegaurdService
    // ],
    // data: {
    //   expectedRole: "Users",
    //   requiredRole : "Admin"
    // }
  }
];
export const appRouting = RouterModule.forRoot(routes,);

const isIframe = window !== window.parent && !window.opener;
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: !isIframe ? 'enabledBlocking' : 'disabled'
  }), CommonModule],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
